/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const ReturnSupplierStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  supplier: {
    name: 'คืนผู้ขาย',
    color: 'info',
    icon: 'task_alt',
  },
  receive: {
    name: 'ผู้ขายรับของ',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default ReturnSupplierStatus;
